var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"dense":"","outlined":"","items":_vm.selectCompanies,"hide-details":"","value":_vm.selectedCompany},on:{"change":_vm.setCompany}})}
var staticRenderFns = []

export { render, staticRenderFns }